"use client"

import { useCallback } from "react"

export const useLocalStorage = () => {
  const getItem = useCallback((key: string): string | null => {
    try {
      return localStorage.getItem(key)
    } catch (error) {
      console.error(`Error reading localStorage key "${key}":`, error)
      return null
    }
  }, [])

  const setItem = useCallback((key: string, value: string): void => {
    try {
      localStorage.setItem(key, value)
    } catch (error) {
      console.error(`Error setting localStorage key "${key}":`, error)
    }
  }, [])

  const removeItem = useCallback((key: string): void => {
    try {
      localStorage.removeItem(key)
    } catch (error) {
      console.error(`Error removing localStorage key "${key}":`, error)
    }
  }, [])

  const clearFlowData = useCallback(() => {
    const keysToRemove = [
      "connectorFlowStep",
      "fieldMappings",
      "hubspot_connected",
      "hubspot_tenant_id",
      "salesforce_connected",
      "selectedConnector",
      "selectedSyncDirection",
      "selectedSyncOption",
    ]

    keysToRemove.forEach((key) => removeItem(key))
  }, [removeItem])

  return { getItem, setItem, removeItem, clearFlowData }
}
